import styled from 'styled-components';
import IconRestartStyled from '../IconRestart/IconRestart.styled';

const IconMenuStyled = styled(IconRestartStyled)`
  position: relative;
  top: -3px;
`;

export default IconMenuStyled;



// WEBPACK FOOTER //
// ./src/components/atoms/IconMenu/IconMenu.styled.js